import { BillingPeriods } from "../../../../util/constants";

export const getCashflowPlanKeyFromName = (planName) => {
  const normalized = String(planName || "").toLowerCase();
  if (normalized.includes("trial")) return "cashflow-trial";
  if (normalized.includes("compact")) return "cashflow-compact";
  if (normalized.includes("core")) return "cashflow-core";
  if (normalized.includes("complete")) return "cashflow-complete";
  return null;
};

export const toPlanTitle = (planKey) => {
  const tier = String(planKey || "")
    .split("-")
    .slice(1)
    .join(" ");
  if (!tier) return "Cash flow";
  return tier.charAt(0).toUpperCase() + tier.slice(1);
};

export const normalizeBillingPeriod = (period) => {
  const value = String(period || "").toLowerCase();
  return value === BillingPeriods.YEARLY || value === "annual"
    ? BillingPeriods.YEARLY
    : BillingPeriods.MONTHLY;
};

const toLimitLabel = (value, label) => {
  if (!Number.isFinite(value) || value <= 0) return null;
  const display = value >= 9999 ? "Unlimited" : String(value);
  return `${display} ${label}`;
};

export const getFeatureLimitDefaults = (features = {}) => {
  const limits = [
    {
      id: "templates",
      label: toLimitLabel(Number(features?.templates), "templates"),
    },
    {
      id: "schedules",
      label: toLimitLabel(Number(features?.schedules), "schedules"),
    },
    {
      id: "emailIntegrationConnections",
      label: toLimitLabel(
        Number(features?.emailIntegrationConnections),
        "email integrations",
      ),
    },
    { id: "sms", label: toLimitLabel(Number(features?.freeSms), "SMS/month") },
    {
      id: "phoneCall",
      label: toLimitLabel(Number(features?.freeCalls), "auto-calls/month"),
    },
    {
      id: "letter",
      label: toLimitLabel(Number(features?.freeLetters), "letters/month"),
    },
  ];

  return limits.filter((item) => Boolean(item.label));
};

export const normalizeOfferPeriod = (period) =>
  period === BillingPeriods.YEARLY
    ? BillingPeriods.YEARLY
    : BillingPeriods.MONTHLY;

export const toSentenceCaseFeatureLabel = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";

  return text
    .split(/\s+/)
    .map((word, index) => {
      if (!/[a-z]/i.test(word)) return word;

      // Preserve acronyms like SMS and VAT.
      if (/^[A-Z0-9/&-]+$/.test(word)) return word;

      if (index === 0) {
        return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
      }

      return word.toLowerCase();
    })
    .join(" ");
};
